<template>
    <div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
            <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Fin de la unidad">
                <div class="container-fluid margen_principal">
                    <div class="row d-flex justify-content-center margen_principal">
                            <div class="col-lg-6 col-md-12 col-sm-12 col-12 text-center">
                                <h3>¡Has finalizado el estudio del contenido de la unidad <span class="font-italic">Etapas de desarrollo</span>!</h3>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-center">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-2">
                                <img src="recursos/img/GAVI/Ten_en_cuenta_que.png" class="img-fluid d-flex mx-auto" alt="">
                            </div>
                            <div class="col-12 col-sm-12 col-md-12 col-lg-4 fondop2 rounded p-4">
                                <h3 class="tal"><span class="AlertaFin i-important p-2 text-white iconos-i"></span> Ten en cuenta</h3>
                                <div class="ulcheck-Fin mt-3">
                                    <ul class="col01-Uni1">
                                        <li class="d-flex"><span class="i-check iconoMediano color1Ppal mr-2"></span><p>Visitar los recursos audiovisuales y talleres del <span class="font-weight-bold font-italic">material complementario</span> del curso.</p></li>
                                        <li class="d-flex"><span class="i-check iconoMediano color1Ppal mr-2"></span><p>Acceder al acompañamiento de tu docente-tutor.</p></li>
                                        <li class="d-flex"><span class="i-check iconoMediano color1Ppal mr-2"></span><p>Desarrollar las actividades evaluativas formuladas para el curso.</p></li>
                                        <li class="d-flex"><span class="i-check iconoMediano color1Ppal mr-2"></span><p>Socializar las dificultades y buenas prácticas de estudio en los foros temáticos.</p></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-12 col-sm-12 col-md-12 col-lg-8 text-center mt-5 mb-5">
                                <h4 class="font-weight-bold">
                                    Continúa con el estudio de la unidad: <span class="font-italic">Interpretación comunitaria</span>
                                </h4>
                                <p class="mt-5">
                                    Este documento es propiedad del Instituto Tecnológico Metropolitano (ITM), Institución universitaria adscrita al municipio de Medellín-Colombia. <br>
                                    El contenido, metodología didáctica y diseño gráfico están protegidos por las leyes que rigen la propiedad intelectual. <br>
                                    Para distribución y uso de todo o parte de este material debe contar con autorización expresa de la Unidad de Educación Virtual ITM.
                                </p>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {SwiperController} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'FinUnidad',
    mounted() {
        SwiperController(), // Cargar controladores de Swiper
        document.title = this.$route.meta.title // Cambiar el título de la página
    },
}
</script>